import { render, staticRenderFns } from "./TabDynamic.vue?vue&type=template&id=3cb30f18"
import script from "./TabDynamic.vue?vue&type=script&lang=js"
export * from "./TabDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports